export default {
    cheatsheet: {
        title: "Folha de apostas",
        empty: {
            noPlaysAvailable: "Nenhuma jogada disponível",
        },
        separators: {
            noLongerPerfect: "Não é mais 100% abaixo disso",
        },
        generate: {
            homeRow: "Gerar sua folha de apostas",
            results: {
                title: "Seu cheatsheet",
                subtitle: "Gerado",
            },
            actions: {
                generate: "Gerar",
            },
            options: {
                all: "Tudo",
            },
            empty: {
                title: "Nenhuma prop encontrada",
                subtitle: "Tente mudar suas seleções para encontrar mais props.",
                action: "Ajustar seleções",
            },
            outcome: {
                title: "O que você está procurando?",
                subtitle: "Escolha Mais ou Menos.",
                over: "Mais",
                under: "Menos",
            },
            propType: {
                title: "O que você prefere?",
                subtitle: "Escolha props de jogador ou equipe.",
                player: "Props de jogador",
                team: "Props de equipe",
            },
            lineType: {
                title: "Quais linhas você quer?",
                subtitle: "Escolha principais ou alternativas.",
                main: "Linhas principais",
                alternate: "Linhas alternativas",
            },
            cheatsheetType: {
                title: "Em que devemos nos basear?",
                subtitle: "Escolha o período para usar como base.",
                recentForm: "Forma recente",
                versusOpponent: "Contra adversário",
                homeAwaySplits: "Casa/fora",
            },
            games: {
                title: "Quais jogos incluir?",
                subtitle: "Inclua todos os jogos ou escolha os que quiser.",
            },
            betTypes: {
                title: "Quais props você quer?",
                subtitle: "Escolha os tipos de aposta que quer incluir.",
            },
            operators: {
                title: "Onde devemos procurar?",
                subtitle: "Escolha as odds que quer incluir.",
            },
            loader: {
                prefix: "Analisando",
                ready: "Folha pronta",
                accessibilityLabel: "Gerando sua folha de apostas",
                values: {
                    overs: "Mais...",
                    unders: "Menos...",
                    mainLines: "Linhas principais...",
                    alternateLines: "Linhas alternativas...",
                    recentForm: "Forma recente...",
                    versusOpponent: "Contra adversário...",
                    homeAwaySplits: "Casa/fora...",
                    todaysGames: "Jogos de hoje...",
                    selectedGames: "{{count}} jogo(s) selecionado(s)...",
                    allBetTypes: "Todos os tipos de aposta...",
                    oneBetType: "{{name}}...",
                    twoBetTypes: "{{first}} e {{second}}...",
                    manyBetTypes: "{{count}} tipos de aposta...",
                    yourSportsbooks: "Suas casas de aposta...",
                    allSportsbooks: "Todas as casas de aposta...",
                    specificSportsbooks: "{{count}} casa(s) de aposta...",
                    building: "Criando seu cheatsheet...",
                },
            },
        },
    },
};
